import { IconCopy } from '@tabler/icons-react'
import copy from 'clipboard-copy'
import { Prism } from 'react-syntax-highlighter'
import { useTheme } from 'styled-components'

import { type StylableElementProps, useSnackbar } from '@subaio/components'

import { ButtonCopy } from './ButtonCopy'
import { Container } from './Container'
import { useSyntaxTheme } from './useSyntaxTheme'

type Props = StylableElementProps & {
	children: string
	language: string
	fontSize?: number
	limitHeight?: boolean

	showLineNumbers?: boolean
}

export const SyntaxHighlighter = ({
	language,
	fontSize = 14,
	limitHeight = true,
	showLineNumbers,
	children,
	style,
	className,
}: Props) => {
	const { showSnackbar } = useSnackbar()
	const { colorScheme } = useTheme()
	const syntaxTheme = useSyntaxTheme({ fontSize, colorScheme })

	return (
		<Container style={style} className={className} colorScheme={colorScheme} limitHeight={limitHeight}>
			<Prism
				language={language}
				style={syntaxTheme}
				// No need to show line numbers for a one-line code example
				showLineNumbers={showLineNumbers ?? children.split(/\n/).length > 1}
			>
				{children}
			</Prism>
			<ButtonCopy
				icon={<IconCopy />}
				size={20}
				colorScheme={colorScheme}
				onClick={() => {
					copy(children)
					showSnackbar({ message: 'Copied to clipboard', duration: 2 })
				}}
			/>
		</Container>
	)
}
